<template>
  <div>
    <div class="right">
      <div class="experience">
        <div class="experience1">
          <img :src="newsExperience1" alt="" />
          <div class="content">
            <div class="title">软硬一体化打通线上线下</div>
            <div class="text">三端协同 数据同步</div>
            <router-link to="/pc/product/things">
              <button class="go">立即体验</button>
            </router-link>
          </div>
        </div>
        <div class="experience1">
          <img :src="newsExperience2" alt="" />
          <div class="content">
            <div class="title">物业管理新升级</div>
            <div class="text">社区生活更美好 为物业赋能</div>
            <router-link to="/pc/product/property">
              <button class="go">立即体验</button>
            </router-link>
          </div>
        </div>
        <div class="experience2">
          <img :src="newsExperience3" alt="" />
          <div class="content">
            <button class="go">立即体验</button>
          </div>
        </div>
      </div>

      <div class="recommend">
        <div class="recommend-title">相关推荐</div>
        <div class="recommend-list">
          <div
            class="recommend-item"
            v-for="item in recommendList"
            :key="item.id"
          >
            <div>
              <img class="recommend-logo" :src="item.logo" alt="" />
            </div>
            <div>
              <div class="recommend-text">{{ item.text }}</div>
              <div class="recommend-date">{{ item.date }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="hot">
        <div class="hot-title">热门标签</div>
        <div class="hot-list">
          <div class="hot-item" v-for="item in hotList" :key="item.id">
            {{ item.title }}
          </div>
        </div>
      </div>

      <div class="hotinformation">
        <div class="hotinformation-flex">
          <div class="hotinformation-title">热门资讯</div>
          <div class="hotinformation-more">
            <div>更多</div>
            <img :src="more" alt="" />
          </div>
        </div>
        <div class="hotinformation-list">
          <div
            class="hotinformation-item"
            v-for="item in hotinformationList"
            :key="item.id"
          >
            <div class="hotinformation-text">{{ item.text }}</div>
            <div class="hotinformation-date">{{ item.date }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import newsExperience1 from "../../../assets/dynamic/newsExperience1.png";
import newsExperience2 from "../../../assets/dynamic/newsExperience2.png";
import newsExperience3 from "../../../assets/dynamic/newsExperience3.png";

import recommendLogo1 from "../../../assets/dynamic/recommendLogo1.png";
import recommendLogo2 from "../../../assets/dynamic/recommendLogo2.png";
import recommendLogo3 from "../../../assets/dynamic/recommendLogo3.png";

import more from "../../../assets/dynamic/more.png";

export default {
  setup() {
    return reactive({
      newsExperience1: newsExperience1,
      newsExperience2: newsExperience2,
      newsExperience3: newsExperience3,
      more: more,
      recommendList: [
        {
          id: 1,
          text: "传统物业与现在的智慧物业相比，智慧物业管理系统有哪些优势？ ",
          date: "2022/07/05",
          logo: recommendLogo1,
        },
        {
          id: 2,
          text: "好的物业管理软件推荐  物业管理软件哪个好用？  ",
          date: "2022/07/14",
          logo: recommendLogo2,
        },
        {
          id: 3,
          text: "好的社区管理系统应该具备什么特点？  ",
          date: "2022/06/15",
          logo: recommendLogo3,
        },
      ],
      hotList: [
        {
          id: 1,
          title: "物业服务品质",
          path: "",
        },
        {
          id: 2,
          title: "智慧园区",
          path: "",
        },
        {
          id: 3,
          title: "物业管理",
          path: "",
        },
        {
          id: 4,
          title: "物业消防检查",
          path: "",
        },
        {
          id: 5,
          title: "物业公司",
          path: "",
        },
        {
          id: 6,
          title: "物业系统",
          path: "",
        },
        {
          id: 7,
          title: "医废管理",
          path: "",
        },
        {
          id: 8,
          title: "智慧社区",
          path: "",
        },
        {
          id: 9,
          title: "物业收费系统",
          path: "",
        },
        {
          id: 10,
          title: "电子巡更系统",
          path: "",
        },
        {
          id: 11,
          title: "不动产数字化",
          path: "",
        },
        {
          id: 12,
          title: "不动产管理",
          path: "",
        },
        {
          id: 13,
          title: "智慧园区管理平台",
          path: "",
        },
        {
          id: 14,
          title: "物业管理软件",
          path: "",
        },
        {
          id: 15,
          title: "智能楼宇",
          path: "",
        },
        {
          id: 16,
          title: "物业管理系统",
          path: "",
        },
        {
          id: 17,
          title: "智慧停车场系统",
          path: "",
        },
        {
          id: 18,
          title: "停车场系统",
          path: "",
        },
        {
          id: 19,
          title: "产业园区",
          path: "",
        },
        {
          id: 20,
          title: "国有资产管理",
          path: "",
        },
        {
          id: 21,
          title: "智慧楼宇",
          path: "",
        },
        {
          id: 22,
          title: "写字楼物业管理",
          path: "",
        },
      ],
      hotinformationList: [
        {
          id: 1,
          text: "传统物业与现在的智慧物业相比，智慧物业管理系统有哪些优势？ ",
          date: "2022/04/18",
        },
        {
          id: 2,
          text: "智慧社区管理相对于服务平台来说究竟有哪些优势？  ",
          date: "2022/06/09",
        },
        {
          id: 3,
          text: "智慧社区管理系统，助力传统社区物业升级  ",
          date: "2022/05/27",
        },
      ],
    });
  },
};
</script>

<style scoped>
.body .right {
  width: 360px;
}
.body .right .experience .experience1 img,
.body .right .experience .experience2 img {
  width: 360px;
}
.body .right .experience .experience1 {
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;
}
.body .right .experience .experience1:hover img,
.body .right .experience .experience2:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .right .experience .experience1 .content {
  position: absolute;
  top: 15%;
  left: 10%;
}
.body .right .experience .experience1 .content .title {
  font-size: 14px;
  color: #fff;
}
.body .right .experience .experience1 .content .text {
  color: #8ea3b9;
  margin-top: 5px;
  font-size: 10px;
}
.body .right .experience .experience1 .content .go {
  width: 64px;
  height: 18px;
  border: none;
  text-align: center;
  background-color: #248efb;
  color: #fff;
  font-size: 10px;
  margin-top: 15px;
  border-radius: 212px 212px 212px 212px;
  cursor: pointer;
}

.body .right .experience .experience2 {
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;
}
.body .right .experience .experience2 .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.body .right .experience .experience2 .content .go {
  width: 136px;
  height: 42px;
  border: none;
  text-align: center;
  background-color: #fff;
  color: #248efb;
  font-size: 18px;
  border-radius: 309px 309px 309px 309px;
  cursor: pointer;
  animation: fadenum 5s;
  animation-iteration-count: infinite;
}
@keyframes fadenum {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.1);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}
.recommend {
  margin-bottom: 60px;
}
.recommend .recommend-title {
  font-size: 30px;
  margin-top: 40px;
}
.recommend-item {
  display: flex;
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dce1e8;
  cursor: pointer;
}
.recommend-logo {
  width: 86px;
  margin-right: 20px;
}
.recommend-text {
  font-size: 16px;
  line-height: 24px;
}
.recommend-date {
  font-size: 14px;
  color: #6f8398;
  margin-top: 10px;
}

.hot {
  margin-bottom: 60px;
}
.hot-title {
  font-size: 30px;
  margin-bottom: 30px;
}
.hot-list {
  display: flex;
  flex-wrap: wrap;
}
.hot-item {
  padding: 8px 10px;
  border: 1px solid #dce1e8;
  font-size: 12px;
  color: #6f8398;
  border-radius: 212px 212px 212px 212px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.hot-item:hover {
  color: #248efb;
  border: 1px solid #248efb;
}

.hotinformation-flex {
  display: flex;
  justify-content: space-between;
}
.hotinformation-title {
  font-size: 30px;
}
.hotinformation-more {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.hotinformation-more div {
  margin-right: 10px;
}
.hotinformation-more img {
  width: 14px;
}

.hotinformation-item {
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dce1e8;
  cursor: pointer;
}
.hotinformation-text {
  font-size: 16px;
}
.hotinformation-date {
  font-size: 14px;
  color: #6f8398;
  margin-top: 10px;
}
</style>
